import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent {
  @ViewChild('videoPlayer') videoplayer: any;
  public startedPlay: boolean = false;
  public show: boolean = false;
  videoSource: any;
  title: any;

  constructor(public dialogRef: MatDialogRef<VideoPlayerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    // this.title = data.title
    this.videoSource = data.url;
  }

  ngOnInit(): void { }

  pauseVideo(videoplayer) {
    videoplayer.nativeElement.pause();
    if (videoplayer.nativeElement.paused) {
      this.show = !this.show;
    }
    setTimeout(() => {
      videoplayer.nativeElement.play();
    }, 1000);
  }
}
